// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-group.special[data-v-36f5fd04] {\n  display: flex;\n}\n.special .btn[data-v-36f5fd04] {\n  flex: 1\n}\n", ""]);
// Exports
module.exports = exports;
